'use client';

import { ToggleLeft, ToggleRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@kit/ui/button';

import type { MeasurementType, Unit, UnitToggleProps } from '../types';

/**
 * Get the display label for a measurement unit
 */
export const getUnitLabel = (type: MeasurementType, unit: Unit): string => {
  if (unit === 'imperial') {
    if (type === 'height') return 'ft/in';
    if (type === 'weight') return 'lbs';
    return 'inches';
  }

  if (type === 'height') return 'cm';
  if (type === 'weight') return 'kg';
  return 'cm';
};

/**
 * Toggle button for switching between metric and imperial units
 * Unit preference persistence is handled by the parent component
 */
export function UnitToggleButton({
  unit,
  measurementType,
  onToggle,
}: UnitToggleProps) {
  const { t } = useTranslation();
  const targetUnit =
    unit === 'metric'
      ? t('dancer:measurement.units.imperial')
      : t('dancer:measurement.units.metric');
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={onToggle}
      className="flex items-center gap-1 text-xs"
      aria-label={t('dancer:measurement.switchToUnits', { unit: targetUnit })}
    >
      {unit === 'metric' ? (
        <ToggleLeft className="h-4 w-4" />
      ) : (
        <ToggleRight className="h-4 w-4" />
      )}
      {getUnitLabel(measurementType, unit)}
    </Button>
  );
}
